import { Typography } from '@mui/material';
import type { BackupJob, RestoreJob, ScanJob } from '@repo/api-gw-sdk';
import classNames from 'classnames';

import { CopyToClipboardWrapper } from '@/components/buttons/copyToClipboardButton';
import { Panels } from '@/components/panels/panels';
import {
  isBackupJob,
  isRestoreJob,
  isScanJob,
} from '@/components/queryBuilder/properties';
import { useViewParameters } from '@/contexts/navigation';
import { useWorkspace } from '@/contexts/useWorkspace';

export const JobResourceNameField = ({
  job,
}: {
  job: BackupJob | RestoreJob | ScanJob;
}) => {
  const { rightPanel } = useWorkspace();
  const { removeParam } = useViewParameters();
  const resourceName = job.resourceDetails?.resourceName;
  const resourceId = job.resourceDetails?.id;

  const onClose = () => {
    rightPanel.setIsOpen(false);
    removeParam('id');
  };

  const onBack = () => {
    if (isRestoreJob(job)) {
      rightPanel.setComponent({
        panel: Panels.RestoreJobsCard,
        props: {
          job,
          onClose,
        },
      });
    } else if (isBackupJob(job)) {
      rightPanel.setComponent({
        panel: Panels.BackupJobsCard,
        props: {
          job,
          onClose,
        },
      });
    } else if (isScanJob(job)) {
      rightPanel.setComponent({
        panel: Panels.ScanJobsCard,
        props: {
          job,
          onClose,
        },
      });
    }
  };

  const handleClick = () => {
    if (!resourceId) return;
    rightPanel.setComponent({
      panel: Panels.InventoryInstance,
      props: {
        id: resourceId,
        initialTab: 'overview',
        onClose,
        onBack,
      },
    });
  };

  return (
    resourceName && (
      <CopyToClipboardWrapper textToCopy={resourceName}>
        <Typography
          variant='subtitle1'
          className={classNames({
            'underline hover:cursor-pointer hover:text-[var(--mui-palette-text-secondary)]':
              resourceId,
          })}
          onClick={handleClick}
        >
          {resourceName}
        </Typography>
      </CopyToClipboardWrapper>
    )
  );
};
